import React, { useState } from 'react'
import BillingInfo from '../register/BillingInfo'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { EXP_REGEX } from '../constants'
import { authedAxios } from '../utils'
import useAlert from '../hooks/useAlert'

const Row = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', mr: -1 }}>{children}</Box>
  )
}

const EditCard = ({ open, setOpen, refetch }) => {
  const { createAlert, createGenericErrorAlert } = useAlert()

  const [billingInfo, setBillingInfo] = useState({
    cardNumber: '',
    cardName: '',
    exp: '',
    streetAddress: '',
    city: '',
    state: '',
    postal: '',
  })

  const handleBillingFieldChange = (newBillingValues) => {
    setBillingInfo(newBillingValues)
  }

  const submit = () => {
    return authedAxios
      .put('/api/billing/payment', billingInfo)
      .then()
      .then(() => {
        refetch()
        setOpen(false)
      })
      .then(() => {
        createAlert({ message: 'Card successfully updated' })
      })
      .catch(createGenericErrorAlert)
  }

  const disabled =
    Object.keys(billingInfo).some((key) => billingInfo[key] === '') ||
    !EXP_REGEX.test(billingInfo.exp)

  return (
    <Dialog open={open}>
      <DialogTitle>Enter a new card</DialogTitle>
      <DialogContent>
        <BillingInfo
          billingInfo={billingInfo}
          handleBillingFieldChange={handleBillingFieldChange}
          Row={Row}
          hideTitle
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false)
          }}
        >
          Never mind
        </Button>
        <Button
          disabled={disabled}
          variant='contained'
          onClick={() => {
            submit()
          }}
        >
          Save Card
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditCard
